import React from 'react';
import ReactDOM from 'react-dom/client';
import 'semantic-ui-css/semantic.min.css'
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import QuantumCircuit from "quantum-circuit"
// import { Helmet } from 'react-helmet';

import App from './App';
import Chat from './Chat'
import Error from './Error'



// Generated in ⟨Quantum|Copilot⟩ and modified
const circuit = new QuantumCircuit(2);
circuit.createCreg("c", 2);
circuit.appendGate("h", 0, {});
circuit.appendGate("cx", [0,1], {});
circuit.addMeasure(0, "c", 0);
circuit.addMeasure(1, "c", 1);
circuit.run();

console.log("Probabilities:");
console.log(JSON.stringify(circuit.probabilities()));

console.log("Measure all:");
console.log(JSON.stringify(circuit.measureAll()));

console.log("Classical registers:");
console.log(circuit.cregsAsString());
const cregs = circuit.cregsAsString()
console.log('cregs:', cregs)

function changeFavicon(url) {
  var link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/x-icon';
  link.href = url;
  document.head.appendChild(link);
}

if (cregs.includes('00')) {
  console.log('creg.includes00')
  changeFavicon('/favicon_io/favicon.ico');
} else if (cregs.includes('11')) {
  console.log('creg.includes11')
  changeFavicon('/favicon2/favicon.ico');
} else {
  console.warn('creg.includes-else')
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  {/*
  <React.StrictMode>
  */}

    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App/>}/>
        <Route path="/chat" element={<Chat/>}/>

        <Route path="*" element={<Error/>}/>
      </Routes>
    </BrowserRouter>
  {/*
  </React.StrictMode>
  */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
